import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BillingManagementService } from 'src/service/billing-management.service';
import { BillingValidation, FocusInputType, KeyValueIdGroup, KeyValues3, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-overwrite-price',
  templateUrl: './overwrite-price.component.html',
  styleUrl: './overwrite-price.component.scss'
})
export class OverwritePriceComponent {
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onCompleted = new EventEmitter();

  @Input() businessId: string = ''; @Input() billingDetailId: string = '';
  @Input() selectedQty: number = null; @Input() currentPrice: number = null;
  @Input() isNotConsiderTax: boolean = false; @Input() businessTaxes: KeyValueIdGroup[] = [];
  @Input() billingValidation: BillingValidation[] = [];

  totalPrice: number = null;

  selectedRadioOption = 1; sourceCurrentPrice: number = null;

  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService, private billingManagementService: BillingManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      btn_currentPrice: 'currentPrice_' + this.htmlId,
      btn_totalPrice: 'totalPrice_' + this.htmlId,
    };
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
    }
  }

  onLoad() {
    this.sourceCurrentPrice = this.currentPrice;
    if (!this.selectedQty) {
      this.selectedQty = 0;
    }
    this.selectedRadioOption = 1;
    setTimeout(() => {
      this.onSetFocus();
      this.onCalculate(true);
    }, 100);
  }

  onSetFocus() {
    this.localService.onFocusNextInput(this.selectedRadioOption == 1 ? this.elementIds.btn_currentPrice : this.elementIds.btn_totalPrice, FocusInputType.TextBox);
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onClosePopup() {
    this.onBeforeDismiss();
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onClosePopup();
      } break;
      case 2: {
        this.onChecked(1);
      } break;
      case 3: {
        this.onChecked(2);
      } break;
      case 4: {
        this.onUpdatePrice();
      } break;
    }
  }

  onChecked(value) {
    this.selectedRadioOption = value;
    this.onSetFocus();
  }

  onCalculate(isPerQty: boolean) {
    if (isPerQty) {
      this.totalPrice = parseFloat((this.currentPrice && this.currentPrice > 0 ? (this.currentPrice * this.selectedQty) : 0).toFixed(2));
    } else {
      this.currentPrice = parseFloat((this.totalPrice && this.totalPrice > 0 ? (this.totalPrice / this.selectedQty) : 0).toFixed(2));
    }
  }

  onUpdatePrice() {
    if (this.sourceCurrentPrice != this.currentPrice) {
      this.billingManagementService.updatePrice(this.businessId, this.billingDetailId, this.currentPrice ?? 0, this.businessTaxes, this.isNotConsiderTax, false, this.billingValidation).subscribe(result => {
        this.onCompleted.emit({
          key: this.billingDetailId,
          v1: this.currentPrice?.toString() ?? '0',
          v2: this.totalPrice?.toString() ?? '0',
        } as KeyValues3);
        this.onClosePopup();
      });
    } else {
      this.onClosePopup();
    }
  }
}
